/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Use_1_ValueInputs */

const en_svc_n8n_use_1_value = /** @type {(inputs: Svc_N8n_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachments read, fields extracted and written to your accounting sheet or system.`)
};

const lv_svc_n8n_use_1_value = /** @type {(inputs: Svc_N8n_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pielikumi tiek nolasīti, lauki iegūti un ierakstīti Jūsu grāmatvedības tabulā vai sistēmā.`)
};

/**
* | output |
* | --- |
* | "Attachments read, fields extracted and written to your accounting sheet or system." |
*
* @param {Svc_N8n_Use_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_use_1_value = /** @type {((inputs?: Svc_N8n_Use_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Use_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_use_1_value(inputs)
	return en_svc_n8n_use_1_value(inputs)
});